<template>
  <cumulus-edit-form-tablet
    ref="form"
    :icon="icon"
    :title="title"
    :new-item="new_item"
    @escape="escape"
    @save="save"
    @remove="remove"
  >
    <template v-slot:editform>
      <edit-form
        :daily-flight="edited_item"
      />
    </template>
  </cumulus-edit-form-tablet>
</template>

<script>
  // Utilities
  import { call, get, sync } from 'vuex-pathify'
  import CumulusEditFormTablet from '@/components/EditFormTablet'

  export default {
    name: 'DailyFlightEdit',
    components: {
      CumulusEditFormTablet,
      EditForm: () => import('@/layouts/default/edit/DailyFlight'),
    },
    data: function () {
      return {
        icon: '$edit',
        title: 'flight_datas',
        edited_item_id: -1,
        edited_item: {},
        loading: false,
        prevRoute: '',
        saved: false,
      }
    },
    computed: {
      profile: get('auth/profile'),
      datas: get('datasource/datas'),
      new_item () { return this.edited_item_id === 'new' },
      operation_date: sync('dailyFlight/operation_date'),
      competitionModuleOn () { return this.profile.organization.modules.filter(m => m.name === 'competition').length > 0 },
    },
    watch: {
      'edited_item.plane_id': {
        handler () {
          if (this.competitionModuleOn) {
            this.loadFlightData()
          }
        },
      },
      'edited_item.sic_id': {
        handler () {
          console.log(this.edited_item.sic_id)
          if (!this.edited_item.sic_id) {
            this.edited_item.cost_sharing = 0
          }
        },
        // deep: true,
      },
    },
    mounted () {
      if (this.$route.name === 'RFID') {
        this.edited_item_id = 'new'
        this.edited_item = {
          record_type: 'pre-flight',
          date: this.operation_date,
          plane_id: parseInt(this.$route.params.plane_id),
          pic_id: this.profile.user_id,
          sic_id: null,
          instructor_id: null,
          task_id: this.competitionModuleOn ? 'tsk_09' : 'tsk_03',
          takeoff_type_id: this.profile.organization.default_takeoff_type_id,
          takeoff_airport_id: this.profile.organization.base_airport_id,
        }
        if (this.edited_item.takeoff_type_id === 'tof_02') {
          if (this.datas['tow-planes'].length === 1) {
            console.log('If only 1 tow plane is available, it is the default')
            this.edited_item.tow_plane_id = this.datas['tow-planes'][0].id
          }
        }
      } else {
        this.fetch()
      }
    },
    methods: {
      fetchEditedItem: call('dailyFlight/fetch'),
      insertEditedItem: call('dailyFlight/insert'),
      updateEditedItem: call('dailyFlight/update'),
      deleteEditedItem: call('dailyFlight/delete'),
      getLastFlight: call('dailyFlight/getLastFlight'),
      async fetch () {
        console.log(this.$route)
        this.edited_item_id = this.$route.params.id
        this.loading = true
        if (!this.new_item) {
          await this.fetchEditedItem(
            {
              id: this.edited_item_id,
            },
          ).then(response => {
            this.edited_item = response
            this.edited_item.record_type = this.edited_item_id[0] === 'p' ? 'pre-flight' : 'flight'
            this.loading = false
          }).catch(e => {
            console.log(e)
            this.$router.push(this.prevRoute.path).catch(() => {})
          })
        } else {
          this.edited_item = {
            record_type: 'pre-flight',
            date: this.operation_date,
            pic_id: null,
            sic_id: null,
            instructor_id: null,
            task_id: this.competitionModuleOn ? 'tsk_09' : 'tsk_03',
            takeoff_type_id: this.profile.organization.default_takeoff_type_id,
            takeoff_airport_id: this.profile.organization.base_airport_id,
          }
          if (this.edited_item.takeoff_type_id === 'tof_02') {
            if (this.datas['tow-planes'].length === 1) {
              console.log('If only 1 tow plane is available, it is the default')
              this.edited_item.tow_plane_id = this.datas['tow-planes'][0].id
            }
          }
        }
      },
      async save () {
        this.loading = true
        if (this.new_item) {
          await this.insertEditedItem(
            this.edited_item,
          ).then(response => {
            this.saved = true
            this.escape()
          }).catch(e => {
            this.loading = false
            this.$refs.form.setErrors(e)
            console.log(e)
          })
        } else {
          await this.updateEditedItem(
            this.edited_item,
          ).then(response => {
            this.saved = true
            this.escape()
          }).catch(e => {
            this.loading = false
            // console.log(e)
            this.$refs.form.setErrors(e)
            // console.log(e)
          })
        }
      },
      async remove () {
        this.loading = true
        await this.deleteEditedItem(
          {
            id: this.edited_item_id,
          },
        ).then(response => {
          this.saved = true
          this.escape()
        }).catch(e => {
          this.loading = false
          this.$refs.form.setErrors(e)
          console.log(e)
        })
      },
      async loadFlightData () {
        await this.getLastFlight({ plane_id: this.edited_item.plane_id })
          .then(response => {
            if (response.length !== 0) {
              this.edited_item.pic_id = response.pic_id
              this.edited_item.sic_id = response.sic_id
              this.edited_item.pay_comment = response.pay_comment
              this.edited_item.takeoff_type_id = response.takeoff_type_id
            } else {
              console.log('Nincs előzmény')
            }
          }).catch(e => {
            this.loading = false
            this.$refs.form.setErrors(e)
            console.log(e)
          })
      },
      escape () {
        this.$router.push('/daily-flight/').catch(() => {})
      },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    },
  }
</script>
